import { defineComponent as w, ref as f, reactive as B, computed as E, watch as C, onMounted as I, triggerRef as W } from "vue";
import { a as k } from "../index-B-c_FIDh.js";
import "../useHammerSwipe-DqcYRvhM.js";
import { u as x } from "../useModel-IfHLT9OI.js";
import { f as v } from "../fastdom-BAe42vQb.js";
import { a as c } from "../const-CZJ2cQu8.js";
import { n as S } from "../_plugin-vue2_normalizer-WQT2Fc8L.js";
import '../assets/DTabs-B8514oIZ.css';var n = /* @__PURE__ */ ((_) => (_.WHITE = "white", _.BLACK = "black", _.GREY = "grey", _))(n || {});
const H = w({
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    items: { type: Array, default: () => [] },
    modelValue: { type: [String, Number], default: void 0 },
    color: { type: String, default: n.BLACK },
    disabled: Boolean,
    /**  растянуть элементы на всю ширину */
    stretch: Boolean
  },
  emits: ["update:modelValue"],
  setup(_, { emit: t }) {
    const o = x(_, "modelValue", t), l = f(null), i = f([]), d = f(null), r = f(null), p = B({ left: 0, right: 0 }), u = f({}), b = (s) => {
      v.measure(() => {
        for (const e of s) {
          const a = e.dataset.key;
          if (!a) return;
          u.value[a] = {
            width: (e == null ? void 0 : e.offsetWidth) ?? 0,
            left: (e == null ? void 0 : e.offsetLeft) ?? 0
          }, W(u);
        }
        if (r.value) {
          const { left: e, right: a } = r.value.getBoundingClientRect();
          p.left = e, p.right = a;
        }
      });
    }, R = E(() => i.value.find((s) => s.dataset.key === o.value)), Y = () => {
      let s = 0, e = 0;
      v.measure(() => {
        var g;
        if (!r.value || !R.value) return;
        const { left: a, right: m } = R.value.getBoundingClientRect(), { left: h, right: y } = p, T = i.value[0].offsetLeft, A = (((g = d.value) == null ? void 0 : g.offsetWidth) ?? 0) - i.value[i.value.length - 1].offsetWidth - i.value[i.value.length - 1].offsetLeft;
        s = y - m - A, e = a - h - T;
      }), v.mutate(() => {
        r.value && (s < 0 && r.value.scrollTo({
          left: r.value.scrollLeft - s,
          behavior: "smooth"
        }), e < 0 && r.value.scrollTo({
          left: r.value.scrollLeft + e,
          behavior: "smooth"
        }));
      });
    };
    k(r, () => {
      var e;
      const s = (e = d.value) == null ? void 0 : e.children;
      s && b(s);
    }), k(d, ([{ target: s }]) => {
      const e = s.children;
      b(e);
    }), C(() => _.items, () => {
      var e;
      const s = (e = d.value) == null ? void 0 : e.children;
      b(s);
    });
    const $ = () => {
      v.mutate(() => {
        var s, e;
        l.value && (l.value.style.setProperty("--tile-width", `${((s = u.value[`${o.value}`]) == null ? void 0 : s.width) ?? 0}px`), l.value.style.setProperty("--tile-left", `${((e = u.value[`${o.value}`]) == null ? void 0 : e.left) ?? 0}px`));
      });
    };
    I(() => {
      var e;
      const s = (e = d.value) == null ? void 0 : e.children;
      s && (b(s), $());
    }), C([o, u], () => {
      $(), Y();
    }, { deep: !0 });
    const V = (s, e, a) => {
      const m = s === o.value, h = {
        [n.BLACK]: a ? c.GREY_166 : c.WHITE_101,
        [n.GREY]: a ? c.GREY_166 : c.GREY_1514,
        [n.WHITE]: a ? c.GREY_517 : c.GREY_1514
      }, y = {
        [n.BLACK]: a ? c.GREY_166 : c.GREY_1514,
        [n.GREY]: a ? c.GREY_166 : c.GREY_1514,
        [n.WHITE]: a ? c.GREY_517 : c.WHITE_101
      };
      return m ? h[e] : y[e];
    }, L = E(() => {
      const s = {};
      return _.items.forEach((e) => {
        s[e.const] = V(e.const, _.color, _.disabled);
      }), s;
    });
    return {
      tileRef: l,
      localValue: o,
      EColor: n,
      listRef: d,
      tabSizes: u,
      iconColors: L,
      tabsRef: r,
      itemsRef: i
    };
  }
}), K = {
  "d-tabs": "_d-tabs_1ie9t_7",
  "d-tabs_stretch": "_d-tabs_stretch_1ie9t_28",
  "d-tabs_color-black": "_d-tabs_color-black_1ie9t_33",
  "d-tabs_color-white": "_d-tabs_color-white_1ie9t_40",
  "d-tabs_color-grey": "_d-tabs_color-grey_1ie9t_50",
  "d-tabs__scrolled": "_d-tabs__scrolled_1ie9t_61",
  "d-tabs__list": "_d-tabs__list_1ie9t_80",
  "d-tabs__list-item": "_d-tabs__list-item_1ie9t_88",
  "d-tabs__list-item_active": "_d-tabs__list-item_active_1ie9t_103",
  "d-tabs__list-item__append": "_d-tabs__list-item__append_1ie9t_106",
  "d-tabs__list-item__prepend": "_d-tabs__list-item__prepend_1ie9t_110",
  "d-tabs__tile": "_d-tabs__tile_1ie9t_120",
  "d-tabs_disabled": "_d-tabs_disabled_1ie9t_136",
  "d-tabs__list-item_disabled": "_d-tabs__list-item_disabled_1ie9t_139"
};
var z = function() {
  var t = this, o = t._self._c;
  return t._self._setupProxy, o("nav", { class: {
    [t.$style["d-tabs"]]: !0,
    [t.$style["d-tabs_color-white"]]: t.color === t.EColor.WHITE,
    [t.$style["d-tabs_color-black"]]: t.color === t.EColor.BLACK,
    [t.$style["d-tabs_color-grey"]]: t.color === t.EColor.GREY,
    [t.$style["d-tabs_disabled"]]: t.disabled,
    [t.$style["d-tabs_stretch"]]: t.stretch
  } }, [o("div", { ref: "tabsRef", class: t.$style["d-tabs__scrolled"] }, [o("div", { ref: "tileRef", class: t.$style["d-tabs__tile"] }), o("ul", { ref: "listRef", class: t.$style["d-tabs__list"] }, t._l(t.items, function(l) {
    return o("li", { key: l.const, ref: "itemsRef", refInFor: !0, class: {
      [t.$style["d-tabs__list-item"]]: !0,
      [t.$style["d-tabs__list-item_active"]]: t.localValue === l.const
    }, attrs: { "data-key": l.const, tabindex: "0" }, on: { click: function(i) {
      t.localValue = t.disabled ? t.localValue : l.const;
    }, keyup: function(i) {
      if (!i.type.indexOf("key") && t._k(i.keyCode, "enter", 13, i.key, "Enter")) return null;
      t.localValue = t.disabled ? t.localValue : l.const;
    } } }, [t.$slots[`prepend-${l.const}`] || t.$scopedSlots[`prepend-${l.const}`] ? o("div", { class: t.$style["d-tabs__list-item__prepend"] }, [t._t(`prepend-${l.const}`, null, { isActive: t.localValue === l.const, iconColor: t.iconColors[l.const] })], 2) : t._e(), t._v(" " + t._s(l.title) + " "), t.$slots[`append-${l.const}`] || t.$scopedSlots[`append-${l.const}`] ? o("div", { class: t.$style["d-tabs__list-item__append"] }, [t._t(`append-${l.const}`, null, { isActive: t.localValue === l.const, iconColor: t.iconColors[l.const] })], 2) : t._e()]);
  }), 0)])]);
}, O = [];
const G = {
  $style: K
};
function M(_) {
  for (var t in G)
    this[t] = G[t];
}
var P = /* @__PURE__ */ S(
  H,
  z,
  O,
  !1,
  M
);
const U = P.exports;
export {
  U as DTabs,
  n as EColor
};
